import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme: Theme) => ({
  sidebarForm: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '320px',
    height: '100%',
    background: theme.palette.background.paper,
    padding: '30px 20px',
    borderRadius: theme.spacing(2),
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)'
  },
  title: {
    marginBottom: theme.spacing(1.5),
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '95%',
    justifyContent: 'start',
    alignItems: 'center',
    paddingBottom: theme.spacing(2)
  },
  inputLabel: {
    width: '100%',
    alignItems: 'center',
    paddingLeft: theme.spacing(1)
  },
  input: {
    borderRadius: theme.spacing(3),
    boxSizing: 'content-box',
    width: '100%',
    border: 'none',
    backgroundColor: theme.palette.background.default,
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(3),
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.contrastText,
        borderWidth: '2px'
      }
    }
  },
  inputText: {
    ...theme.typography.body1
  },
  invalidCredential: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(1)
  },
  loginButton: {
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: '20px',
    width: '5.5rem',
    height: '2.2rem',
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
    '&:hover': {
      background: theme.palette.primary.dark
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey['200']
    },
    [theme.breakpoints.only('xl')]: {
      width: '6.5rem',
      height: '2.8rem'
    }
  },
  loginButtonText: {
    fontWeight: 500
  },
  sidebarLoggedItem: {
    width: '20rem',
    padding: '1rem',
    background: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.only('xl')]: {
      width: '22rem',
      padding: '1rem 0.5rem'
    }
  },
  gridLoggedItem: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    alignItems: 'flex-start'
  },
  loggedItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    color: theme.palette.primary.dark,
    justifyContent: 'flex-start',
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.6
    }
  }
}))
